const formatError = (invalidPaths) =>
  `There are pages which are not included in the sitemap. Either add a 'sitemapTitle' in the context for these, or add them to the exclusions list.\n\n${invalidPaths
    .map((_) => `* ${_.path}`)
    .join("\n")}`;

export const convertToHTMLPath = (path) =>
  path && path.endsWith(".html") ? path : path + ".html";

const sortByTitles = (pages) =>
  pages
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((page) => ({
      ...page,
      children: sortByTitles(page.children),
    }));

export function reduceToTree(pages) {
  const invalid = pages.filter(({ context }) => !context.sitemapTitle);
  if (invalid.length) {
    throw new Error(formatError(invalid));
  }

  // Sort the URLs into order first
  const sorted = pages.sort((a, b) => a.path.localeCompare(b.path));
  const allPaths = pages.map((page) => page.path);

  // This is the base of the tree, but we only return the children to flatten it out
  const base = { children: [] };

  for (const page of sorted) {
    // Get the URL parts between the slashes
    const parts = page.path.match(/\/[^/]+/g);
    let current = base;

    parts.forEach((_part, i) => {
      let currPath = convertToHTMLPath(parts.slice(0, i + 1).join(""));
      const child = current.children.find((e) => e.path === currPath);

      if (child) {
        current = child;
      } else if (allPaths.includes(currPath)) {
        current.children.push({
          children: [],
          path: currPath,
          title: page.context.sitemapTitle,
        });

        current = current.children[current.children.length - 1];
      }
    });
  }

  return sortByTitles(base.children);
}
